import React, { useContext, useState } from 'react'
import nrt_logo from '../../assets/images/nrt_logo.png'
import { Link } from 'react-router-dom'
import telegram_gif from '../../assets/images/telegram_gif.gif'
import LoginContext from '../../context'
const LoginPopup = () => {

    const { isLogiPopupOpen, closeLoginPopup, login, loading, error } = useContext(LoginContext)
    const [userid, setUserid] = useState("")
    const [passwd, setPasswd] = useState("")

    const handleLogin = async () => {
        if (!userid || !passwd) {
            alert("아이디와 비밀번호를 입력하세요.");
            return;
        }
        await login(userid, passwd)
        setPasswd('')
        setUserid('')
    }
    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            handleLogin();
        }
    }
    return (
        <>
            <div className={`fixed w-full h-[100dvh] bg-[#000c] top-0 left-0 z-[99999]  backdrop-blur-[5px] lg:backdrop-blur-[0px] ${isLogiPopupOpen ? 'block' : 'hidden'} `}>
                <div className='w-[320px] lg:w-[400px] bg-[#00000088] lg:bg-charcoal backdrop-blur-[10px] lg:backdrop-blur-[0px]  absolute -translate-x-2/4 -translate-y-2/4 text-center shadow-[0px_0px_10px_#01278f,_0px_0px_30px_#2782f2] lg:shadow-[#000_0.1em_0.1em_0.3em] cursor-pointer lg:rounded-[10px] border border-[#1f1f1f] lg:border-indigoBlue left-2/4 top-2/4'>
                    <button className='absolute z-[9] right-2.5 top-2.5' onClick={closeLoginPopup}><i className='icofont icofont-close-line inline-block text-[40px] lg:text-[50px] text-skyblue lg:text-silver  rotate-0 duration-[0.5s]  leading-[1]  lg:hover:text-white hover:rotate-[360deg] transition-all'></i></button>

                    <form action="" className='p-0 lg:p-[30px]' onKeyDown={handleKeyDown}>
                        <img src={nrt_logo} alt="" className='w-[70%] lg:w-[280px] object-center mt-10 lg:mt-0 lg:mb-5 mx-auto' />
                        <div className='p-5 lg:p-0'>
                            <input
                                name="userid"
                                value={userid}
                                onChange={(e) => setUserid(e.target.value)}
                                type="text"
                                id="userid"
                                className='h-[46px] lg:h-[45px] bg-black lg:bg-obsidian outline-none text-center w-full leading-[36px] lg:leading-[33px] px-[5px] py-0.5 text-sm transition-[0.2s] text-white mt-2.5 rounded-[3px] lg:rounded-[10px] border border-[#4c4524] lg:border-slate placeholder:text-[#fff4cf] lg:placeholder:text-[#9ca3af]'
                                size="15"
                                maxlength="20"
                                placeholder="아이디"
                            />
                            <input
                                name="passwd"
                                value={passwd}
                                onChange={(e) => setPasswd(e.target.value)}
                                type="password"
                                id="passwd"
                                className='h-[46px] lg:h-[45px] bg-black lg:bg-obsidian outline-none text-center w-full leading-[36px] lg:leading-[33px] px-[5px] py-0.5 text-sm transition-[0.2s] text-white mt-2.5 rounded-[3px] lg:rounded-[10px] border border-[#4c4524] lg:border-slate placeholder:text-[#fff4cf] lg:placeholder:text-[#9ca3af]'
                                size="15"
                                maxlength="20"
                                placeholder="비밀번호"
                            />
                            <button
                                onClick={handleLogin}
                                disabled={loading}
                                id="login-btn"
                                type="submit"
                                className='w-full h-[46px] lg:h-[50px] leading-[46px] lg:leading-[50px] text-[13px] lg:text-base block font-bold transition-[0.3s] text-aquaBlue lg:text-white mb-2.5 lg:rounded-[10px] mt-2.5 lg:mt-5 bg-[#0f0f0f] lg:bg-blue-glow border border-[#2f2f2f] lg:border-[#0306d4] hover:bg-navyBlue lg:hover:bg-blue-glow hover:text-skyblue lg:hover:text-white  lg:hover:filter lg:hover:brightness-[1.5]'
                                value="LOGIN"
                                border="0"
                            >
                                로그인
                            </button>
                            {error && <p className="text-red-500 mt-2">{error}</p>}
                            <Link to="#" id="join-btn" className='w-full h-[46px] lg:h-[50px] leading-[46px] lg:leading-[50px] text-[13px] lg:text-base block font-bold transition-[0.3s] text-aquaBlue lg:text-white mb-2.5 lg:rounded-[10px] bg-[#0f0f0f] lg:bg-blue-glow border border-[#2f2f2f] lg:border-[#0306d4] hover:bg-navyBlue lg:hover:bg-blue-glow hover:text-skyblue lg:hover:text-white  lg:hover:filter lg:hover:brightness-[1.5]' >회원가입</Link>
                            <div className="">
                                <a href="#" target="_blank"><img src={telegram_gif} className='w-full' /></a>
                            </div>
                        </div>
                    </form>

                </div>
            </div>
        </>
    )
}

export default LoginPopup